/* eslint-disable no-restricted-imports */
import { type ComponentProps, forwardRef } from 'react';

import { chakra } from '@chakra-ui/react';
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router-dom';

export interface Props extends RouterLinkProps {
  baseUrl?: string;
}

const LinkComponent = forwardRef<HTMLAnchorElement, Props>(
  ({ to, baseUrl = '', ...props }, ref) => {
    const linkPath = `${baseUrl}${to}`;
    return <RouterLink ref={ref} to={linkPath} {...props} />;
  }
);
LinkComponent.displayName = 'Link';

export const Link = chakra(LinkComponent);
export type LinkProps = ComponentProps<typeof Link>;
